/**
 * Hook para gestión de permisos de Margins/Analytics Dashboard
 * Migrado a usar el hook centralizado usePermissions
 *
 * @deprecated Usar import { useMarginsPermissions } from './usePermissions' directamente
 */
import { useMarginsPermissions as usePermissionsHook } from "./usePermissions";

export interface MarginsPermissions {
  canViewDashboard: boolean;
  canExportDashboard: boolean;
  canViewDetails: boolean;
  canViewAnalytics: boolean;
  canViewProducts: boolean;
  canViewStores: boolean;
  canExportData: boolean;
  canCompareData: boolean;
  isLoading: boolean;
}

/**
 * Hook de permisos para Margins Dashboard
 * Ahora delega al hook centralizado para eliminar lógica duplicada
 */
export function useMarginsPermissions(): MarginsPermissions {
  const result = usePermissionsHook();

  return {
    canViewDashboard: result["canViewDashboard"] || false,
    canExportDashboard: result["canExportDashboard"] || false,
    canViewDetails: result["canViewDetails"] || false,
    canViewAnalytics: result["canViewAnalytics"] || false,
    canViewProducts: result["canViewProducts"] || false,
    canViewStores: result["canViewStores"] || false,
    canExportData: result["canExportData"] || false,
    canCompareData: result["canCompareData"] || false,
    isLoading: result.isLoading,
  };
}
